<template>
<div class="chapter">
<div class="inner_page">
<div id="copy">
<p class="Copyright"><span>© 2024 Kim Sanders</span></p>
<p class="Copyright">All rights reserved. No part of this book may be used or reproduced in any manner without written permission except in the case of brief quotations embodied in critical articles or reviews.</p>
<p class="Copyright">This is a work of fiction. Any similarity to real persons, living or dead, is coincidental and not intended by the author.</p>
<p class="Copyright"><span class="Italics _idGenCharOverride-1">Hermit of Paradise</span></p>
<p class="Copyright">Brown Books Publishing Group</p>
<p class="Copyright0">Dallas, TX/New York, NY</p>
<p class="Copyright0"><a href="http://www.BrownBooks.com" target="_blank">www.BrownBooks.com</a></p>
<p class="Copyright0">(972) 381-0009</p>
<p class="Copyright">A New Era in Publishing®</p>
<p class="Copyright">Publisher’s Cataloging-In-Publication Data</p>
<p class="Copyright ParaOverride-1">Names: Sanders, Kim, 1952- author.</p>
<p class="Copyright0 ParaOverride-1">Title: Hermit of paradise / Kim Sanders.</p>
<p class="Copyright0 ParaOverride-1">Description: Dallas, TX ; New York, NY : Brown Books Publishing Group, [2024]</p>
<p class="Copyright0 ParaOverride-1">Identifiers: ISBN: 978-1-61254-692-6 (hardcover) | LCCN: 2024941165</p>
<p class="Copyright0 ParaOverride-1">Subjects: LCSH: Detectives--Fiction. | Best friends--Fiction. | Murder--Investigation--Fiction. | Rape--Investigation--Fiction. | LCGFT: Detective and mystery fiction. | Bildungsromans. | BISAC: FICTION / Literary. | FICTION / Coming of Age. | FICTION / Crime.</p>
<p class="Copyright0 ParaOverride-1">Classification: LCC: PS3619.A52695 H47 2024 | DDC: 813/.6--dc23</p>
<p class="Copyright">eISBN 978-1-61254-732-9</p>
<p class="Copyright0">LCCN 2024941165</p>
<p class="Copyright">Printed in the United States</p>
<p class="Copyright0">10 9 8 7 6 5 4 3 2 1</p>
<p class="Copyright">For more information or to contact the author, please go to</p>
<p class="Copyright0"><a href="http://www.BrownBooks.com" target="_blank">www.BrownBooks.com</a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03-copy.vue?25139c99